import React from "react";

export const PlaneIcon = ({ className = "", size = 40 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} className={className} fill="currentColor">
    <path d="M21 16v-2l-8-5V3.5A1.5 1.5 0 0 0 11.5 2 1.5 1.5 0 0 0 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5L21 16z" />
  </svg>
);

/* Recognizable world map with continents, Türkiye (IST) & El Salvador (SAL) marked + flight path */
export const WorldMapArt = ({ className = "", color = "var(--gold)" }) => (
  <svg viewBox="0 0 360 210" className={className} preserveAspectRatio="xMidYMid meet">
    {/* graticule (globe grid) */}
    <g stroke={color} strokeOpacity="0.14" strokeWidth="0.5">
      {[30, 60, 90, 120, 150, 180].map((y) => <line key={"h" + y} x1="10" y1={y} x2="350" y2={y} />)}
      {[40, 90, 140, 190, 240, 290, 340].map((x) => <line key={"v" + x} x1={x} y1="20" x2={x} y2="190" />)}
    </g>
    <g fill={color} fillOpacity="0.62" stroke={color} strokeOpacity="0.85" strokeWidth="0.7" strokeLinejoin="round">
      {/* North America */}
      <path d="M34 40 C 22 44 20 58 30 62 C 34 70 44 72 50 68 L 58 74 C 66 72 74 66 72 58 C 84 56 92 48 84 42 C 88 34 78 28 68 32 C 58 24 42 26 38 34 C 34 36 33 38 34 40 Z" />
      {/* Central America isthmus */}
      <path d="M70 74 C 66 80 74 86 80 88 C 86 92 90 98 96 100 L 92 88 C 88 80 80 74 70 74 Z" />
      {/* South America */}
      <path d="M98 104 C 88 102 84 114 90 130 C 94 148 104 168 112 164 C 122 158 118 134 116 120 C 114 108 108 102 98 104 Z" />
      {/* Europe */}
      <path d="M176 46 C 166 46 162 56 172 60 C 178 62 188 58 192 50 C 194 44 186 42 178 44 Z" />
      {/* Africa */}
      <path d="M182 66 C 170 70 172 92 184 116 C 192 132 208 130 210 110 C 214 92 210 74 200 68 C 194 62 188 62 182 66 Z" />
      {/* Asia */}
      <path d="M200 40 C 220 30 272 30 312 44 C 336 52 340 68 320 74 C 298 80 262 76 236 78 C 216 80 200 70 198 52 C 197 46 197 42 200 40 Z" />
      {/* India */}
      <path d="M244 78 C 240 86 248 100 256 98 C 262 94 260 82 254 78 Z" />
      {/* SE Asia / Indonesia dots */}
      <circle cx="300" cy="96" r="4" /><circle cx="312" cy="102" r="3" /><circle cx="322" cy="98" r="2.6" />
      {/* Australia */}
      <path d="M306 132 C 292 130 290 148 306 154 C 324 158 340 146 332 130 C 326 122 316 124 306 132 Z" />
    </g>
    {/* flight path IST -> SAL */}
    <path d="M214 56 C 176 14 92 22 82 96" fill="none" stroke={color} strokeWidth="1.8" strokeDasharray="4 5" opacity="0.95" />
    {/* midpoint heart */}
    <path d="M143 26 c 4 -6 14 -6 14 2 c 0 6 -10 10 -14 14 c -4 -4 -14 -8 -14 -14 c 0 -8 10 -8 14 -2 Z" fill="none" stroke={color} strokeWidth="1" opacity="0.7" transform="scale(0.5) translate(150 20)" />
    {/* Türkiye marker */}
    <g>
      <polygon points="214,48 216,55 224,55 217.5,59.5 220,67 214,62.5 208,67 210.5,59.5 204,55 212,55" fill={color} />
      <text x="214" y="43" fill={color} fontSize="8.5" fontFamily="JetBrains Mono" textAnchor="middle" letterSpacing="1">TÜRKİYE</text>
    </g>
    {/* El Salvador marker */}
    <g>
      <circle cx="82" cy="96" r="3.4" fill={color} />
      <text x="82" y="112" fill={color} fontSize="8.5" fontFamily="JetBrains Mono" textAnchor="middle" letterSpacing="1">EL SALVADOR</text>
    </g>
  </svg>
);



/* Laurel wreath crest with monogram initials */
export const Crest = ({ size = 130, left = "B", right = "F", color = "var(--gold)" }) => {
  const cx = 100, cy = 108, R = 68;
  const angles = [252, 234, 216, 198, 180, 162, 144, 126, 108];
  const leaf = (a, k) => {
    const rad = (a * Math.PI) / 180;
    const x = cx + R * Math.cos(rad);
    const y = cy + R * Math.sin(rad);
    return (
      <g key={k} transform={`translate(${x} ${y}) rotate(${a + 90})`}>
        <ellipse rx="4.6" ry="11" fill={color} opacity="0.92" />
      </g>
    );
  };
  return (
    <svg viewBox="0 0 200 200" width={size} height={size}>
      {/* left branch */}
      <g>{angles.map((a, i) => leaf(a, "l" + i))}</g>
      {/* right branch (mirror) */}
      <g transform="translate(200 0) scale(-1 1)">{angles.map((a, i) => leaf(a, "r" + i))}</g>
      {/* top sprig */}
      <g transform={`translate(${cx} 30)`} fill={color}>
        <ellipse cx="0" cy="0" rx="3.4" ry="9" />
        <ellipse cx="-9" cy="6" rx="3" ry="8" transform="rotate(-35 -9 6)" />
        <ellipse cx="9" cy="6" rx="3" ry="8" transform="rotate(35 9 6)" />
      </g>
      {/* monogram */}
      <line x1="100" y1="72" x2="100" y2="150" stroke={color} strokeWidth="1.6" opacity="0.7" />
      <text x="82" y="128" textAnchor="middle" fill={color} fontFamily="Cormorant Garamond" fontSize="52" fontWeight="700">{left}</text>
      <text x="118" y="128" textAnchor="middle" fill={color} fontFamily="Cormorant Garamond" fontSize="52" fontWeight="700">{right}</text>
    </svg>
  );
};

/* Biometric passport chip symbol */
export const Chip = ({ size = 26, color = "var(--gold)" }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="1.4">
    <rect x="4" y="6" width="16" height="12" rx="2" />
    <path d="M12 6 v12 M4 12 h4 a2 2 0 0 0 2 -2 M20 12 h-4 a2 2 0 0 1 -2 2" />
    <circle cx="12" cy="12" r="2" fill={color} stroke="none" />
  </svg>
);


export const HeartIcon = ({ className = "", size = 18 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} className={className} fill="currentColor">
    <path d="M12 21s-6.7-4.35-9.33-8.24C.9 10.13 1.53 6.7 4.2 5.4c2-1 4.2-.3 5.4 1.2L12 9l2.4-2.4c1.2-1.5 3.4-2.2 5.4-1.2 2.67 1.3 3.3 4.73 1.53 7.36C18.7 16.65 12 21 12 21z" />
  </svg>
);

/* Dotted world map (simplified pointillist continents) */
export const WorldMap = ({ className = "", color = "currentColor" }) => (
  <svg viewBox="0 0 800 360" className={className} preserveAspectRatio="xMidYMid meet">
    <g fill={color}>
      {Array.from({ length: 900 }).map((_, i) => {
        const seed = (i * 9301 + 49297) % 233280;
        const rnd = seed / 233280;
        const seed2 = (i * 4021 + 7919) % 233280;
        const rnd2 = seed2 / 233280;
        const x = rnd * 800;
        const y = rnd2 * 360;
        const inLand =
          (x > 90 && x < 230 && y > 70 && y < 200) ||
          (x > 150 && x < 240 && y > 200 && y < 320) ||
          (x > 360 && x < 430 && y > 70 && y < 150) ||
          (x > 370 && x < 460 && y > 150 && y < 300) ||
          (x > 430 && x < 560 && y > 70 && y < 170) ||
          (x > 560 && x < 720 && y > 90 && y < 210) ||
          (x > 640 && x < 720 && y > 230 && y < 300);
        if (!inLand) return null;
        return <circle key={i} cx={x} cy={y} r={1.6} opacity={0.55} />;
      })}
    </g>
  </svg>
);

/* Compass rose */
export const Compass = ({ className = "", size = 260 }) => (
  <svg viewBox="0 0 200 200" width={size} height={size} className={className}>
    <g fill="none" stroke="var(--gold)" strokeWidth="1" opacity="0.55">
      <circle cx="100" cy="100" r="86" />
      <circle cx="100" cy="100" r="70" strokeDasharray="2 4" />
      <circle cx="100" cy="100" r="52" />
    </g>
    {Array.from({ length: 72 }).map((_, i) => {
      const a = (i * 5 * Math.PI) / 180;
      const r1 = i % 6 === 0 ? 60 : 66;
      const x1 = 100 + Math.cos(a) * r1;
      const y1 = 100 + Math.sin(a) * r1;
      const x2 = 100 + Math.cos(a) * 70;
      const y2 = 100 + Math.sin(a) * 70;
      return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke="var(--gold)" strokeWidth="0.7" opacity="0.5" />;
    })}
    <g fill="var(--gold)">
      <polygon points="100,22 108,100 100,92 92,100" opacity="0.95" />
      <polygon points="100,178 108,100 100,108 92,100" opacity="0.7" />
      <polygon points="22,100 100,92 92,100 100,108" opacity="0.8" />
      <polygon points="178,100 100,92 108,100 100,108" opacity="0.8" />
    </g>
    <g fill="var(--gold-light)">
      <polygon points="100,40 106,100 100,96 94,100" />
      <polygon points="100,160 106,100 100,104 94,100" opacity="0.6" />
      <polygon points="40,100 100,94 96,100 100,106" opacity="0.7" />
      <polygon points="160,100 100,94 104,100 100,106" opacity="0.7" />
    </g>
    <circle cx="100" cy="100" r="6" fill="var(--gold-light)" />
    <text x="100" y="16" fill="var(--gold)" fontSize="13" textAnchor="middle" fontFamily="Cormorant Garamond">N</text>
    <text x="100" y="196" fill="var(--gold)" fontSize="13" textAnchor="middle" fontFamily="Cormorant Garamond">S</text>
    <text x="8" y="105" fill="var(--gold)" fontSize="13" textAnchor="middle" fontFamily="Cormorant Garamond">W</text>
    <text x="192" y="105" fill="var(--gold)" fontSize="13" textAnchor="middle" fontFamily="Cormorant Garamond">E</text>
  </svg>
);

export const Stamp = ({ className = "" }) => (
  <div className={`stamp ${className}`}>
    <svg viewBox="0 0 120 120" width="110" height="110">
      <g fill="none" stroke="var(--gold-dark)" strokeWidth="1.5">
        <circle cx="60" cy="60" r="52" strokeDasharray="2 3" />
        <circle cx="60" cy="60" r="42" />
      </g>
      <PlaneWrap />
      <path id="tc" d="M60,60 m-32,0 a32,32 0 1,1 64,0 a32,32 0 1,1 -64,0" fill="none" />
      <text fill="var(--gold-dark)" fontSize="9" letterSpacing="2" fontFamily="Outfit">
        <textPath href="#tc" startOffset="4%">TOGETHER · FOREVER · TOGETHER · FOREVER ·</textPath>
      </text>
    </svg>
  </div>
);

const PlaneWrap = () => (
  <g transform="translate(42,42)" fill="var(--gold-dark)">
    <path d="M18 12v-1.5l-6-3.7V3.2a1.1 1.1 0 0 0-2.2 0v3.6l-6 3.7V12l6-1.9V14l-1.5 1.1v1.1l2.6-.75 2.6.75v-1.1L15 14v-3.9L18 12z" />
  </g>
);

export const Divider = ({ className = "" }) => (
  <div className={`flex items-center justify-center gap-3 ${className}`}>
    <span className="h-px w-16 sm:w-24 bg-current opacity-30" />
    <HeartIcon size={12} />
    <span className="h-px w-16 sm:w-24 bg-current opacity-30" />
  </div>
);
